import _implicitStylesheets from "./installs.css";
import _implicitScopedStylesheets from "./installs.scoped.css?scoped=true";
import _aceLink from "ace/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="appx-recent-number${0}"${2}><em${3}><span class="install-counter${0}"${"a2:id"}${2}>${"t3"}</span><span class="appx-recent-number-label${0}"${2}>${"t5"}</span></em><i${3}>${"t7"}</i></div>`;
const $fragment2 = parseFragment`<a${"a0:id"} class="appx-tile--mini${0}"${"a0:href"} target="_self"${"a0:title"}${2}><span class="appx-tile--mini-img${0}"${2}><img${"a2:src"}${"a2:alt"}${3}></span><span class="appx-tile--mini-title${0}"${2}>${"t4"}</span><span class="appx-tile--mini-footer${0}"${2}>${"t6"}</span></a>`;
const $fragment3 = parseFragment`<div${3}><em${3}><div class="text appx-recent-number-text1${0}"${2}></div></em><div class="text appx-recent-number-text2${0}"${2}></div></div>`;
const $fragment4 = parseFragment`<li class="li-tile${0}"${2}><div class="card${0}"${2}><div class="logo${0}"${2}></div><div class="card-text${0}"${2}><div class="text appx-recent-number-text1${0}"${2}></div><div class="text appx-recent-number-text2${0}"${2}></div></div></div></li>`;
const stc0 = {
  classMap: {
    "appx-content-inner": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "appx-recent": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "appx-recent-apps": true
  },
  key: 4
};
const stc3 = {
  key: 5
};
const stc4 = {
  "li-tile": true
};
const stc5 = {
  key: 7
};
const stc6 = {
  classMap: {
    "appx-content-inner": true
  },
  key: 10
};
const stc7 = {
  classMap: {
    "appx-recent": true,
    "loading": true
  },
  key: 11
};
const stc8 = {
  classMap: {
    "appx-recent-apps": true
  },
  key: 14
};
const stc9 = {
  key: 15
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, fid: api_scoped_frag_id, c: api_custom_element, h: api_element, i: api_iterator} = $api;
  return [!$cmp.store.isEmpty ? !$cmp.store.isError ? !$cmp.store.isLoading ? api_element("div", stc0, [api_element("div", stc1, [api_static_fragment($fragment1, 3, [api_static_part(2, {
    attrs: {
      "id": api_scoped_id("appInstallCounter")
    }
  }, null), api_static_part(3, null, api_dynamic_text($cmp.store.currentInstalls)), api_static_part(5, null, api_dynamic_text($cmp.i18n.installs.installs)), api_static_part(7, null, api_dynamic_text($cmp.i18n.installs.solutionsJustInstalled))]), api_element("div", stc2, [api_element("ul", stc3, api_iterator($cmp.store.installs, function (listing) {
    return api_element("li", {
      classMap: stc4,
      key: api_key(6, listing.id)
    }, [api_custom_element("ace-link", _aceLink, stc5, [api_static_fragment($fragment2, 9, [api_static_part(0, {
      attrs: {
        "id": api_scoped_id(listing.id),
        "href": api_scoped_frag_id(listing.url),
        "title": listing.name
      }
    }, null), api_static_part(2, {
      attrs: {
        "src": listing.logoUrl,
        "alt": listing.logoText
      }
    }, null), api_static_part(4, null, api_dynamic_text(listing.name)), api_static_part(6, null, api_dynamic_text(listing.lastInstallDate))])])]);
  }))])])]) : null : null : null, !$cmp.store.isEmpty ? !$cmp.store.isError ? $cmp.store.isLoading ? api_element("div", stc6, [api_element("div", stc7, [api_static_fragment($fragment3, 13), api_element("div", stc8, [api_element("ul", stc9, api_iterator($cmp.loopFourTimes, function (key) {
    return api_static_fragment($fragment4, api_key(17, key));
  }))])])]) : null : null : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1b7vv3jmqll";
tmpl.legacyStylesheetToken = "undefined-_installs";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
